<div class="fc-article-list-header">&nbsp;</div>
<h1 [innerHtml]="page.heading"></h1>
<div *ngIf="page.summary" class="fc-article-list-summary" [innerHtml]="page.summary | marked"></div>
<fc-disclaimer *ngIf="disclosure" [message]="disclosure" [showLink]="showGenericLink"></fc-disclaimer>
<fc-display-articles [articles]="page.articles"></fc-display-articles>